export const SUCCESS_CORPORATE_REDIRECT_URL = "https://glotio.com/";
export const SUCCESS_CONSULTANT_REDIRECT_URL = "https://glotio.com/";
export const GLOTIO_BASE_DOMAIN = "https://glotio.com/";
export const TOOLS_ASSISTANT_HELP = "https://calendly.com/d/g4c-wrc-2f4/demo-glotio"
export const SHOPIFY_ADMIN_URL = "https://admin.shopify.com"
export const SHOPIFY_LOGIN = "https://www.shopify.com/login"
